



















import { SalesOrgImportDto } from '@/services/connecteur'
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import SalesOrgImportCard from './SalesOrgImportCard.vue'

@Component({
  components: {
    SalesOrgImportCard
  }
})
export default class SalesOrgImportStatusDialog extends Vue {
  @Prop({ required: true })
  public importStatus!: SalesOrgImportDto[]

  public isOpen = false

  public get color(): string {
    switch (this.numberSuccess) {
      case 1:
        return 'darkorange'
      case 2:
        return 'green'
      default:
        return 'red'
    }
  }

  public get icon(): string {
    return this.numberSuccess > 0 ? 'check-circle' : 'times-circle'
  }

  public get haveNoExport() {
    return !this.importStatus || this.importStatus.length === 0
  }

  public get numberSuccess(): number {
    return this.importStatus.reduce((previousValue: number, currentValue: SalesOrgImportDto) => {
      return previousValue + +(currentValue.isSuccess ?? false)
    }, 0)
  }
}
